<template>
<v-card style="width:400px;margin:0 auto;margin-top:30px;padding-top:10px">
        <v-img
          :src="require('../assets/userinfo.svg')"
          width="200"
          style="margin:0 auto;"
        ></v-img>
        <v-list subheader style="padding-bottom:0px;margin-top:10px;">
        <v-divider></v-divider>
          <v-list-tile >
            <v-list-tile-avatar>
              <img :src="require('../assets/name.svg')">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title >{{user.UserName}}</v-list-tile-title>
            </v-list-tile-content>
             </v-list-tile>
        <v-divider></v-divider>
          <v-list-tile >
            <v-list-tile-avatar>
              <img :src="require('../assets/phone.svg')">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title >{{user.phone}}</v-list-tile-title>
            </v-list-tile-content>
             </v-list-tile>

        <v-divider></v-divider>
          <v-list-tile >
            <v-list-tile-avatar >
              <img :src="require('../assets/gmail.svg')" style="border-radius:0px;padding:5px">
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title >{{user.Email}}</v-list-tile-title>
            </v-list-tile-content>
             </v-list-tile>
        <v-divider></v-divider>
          <v-list-tile >
            <v-list-tile-avatar >
              <img :src="require('../assets/rupee.svg')" >
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title >₹ {{balance}}</v-list-tile-title>
            </v-list-tile-content>
             </v-list-tile>
        <v-divider></v-divider>
          <v-list-tile @click="logout">
            <v-list-tile-avatar >
              <img :src="require('../assets/logout.svg')" >
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title >Logout</v-list-tile-title>
            </v-list-tile-content>
             </v-list-tile>
        </v-list>
      </v-card>
</template>

<script>
export default {
  computed:{
    user(){
      return this.$store.getters.user
    },
    balance(){
      return this.$store.getters.balance
    }
  },
  watch:{
    user(value){
      if(value.phone){
       this.$store.dispatch("getbalance")
      }
    }
  },
  methods:{
    logout(){
      let vm = this;
      window.localStorage.removeItem("user");
      vm.$store.dispatch("getuser");
    }
  },
  mounted(){
      let vm = this;
      if(vm.user.phone){
       this.$store.dispatch("getbalance")
      }
  }
}
</script>
